// SVG markup (as a string) for a close/dismiss icon, for contexts that build DOM imperatively and
// assign innerHTML rather than rendering JSX.
export const CLOSE_ICON = `
  <svg xmlns="http://www.w3.org/2000/svg" class="ionicon" viewBox="0 0 512 512">
    <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
          stroke-width="32" d="M368 368L144 144M368 144L144 368"/>
  </svg>`;
